import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Folder {
    name: string;
    uuid: string;
    folder_name: string;
}

interface FolderState {
    activeFolders: Folder[]; 
}

const initialState: FolderState = {
    activeFolders: JSON.parse(sessionStorage.getItem('activeFolders') ?? '[]'), 
};

const folderSlice = createSlice({
    name: 'folder',
    initialState,
    reducers: {
        addFolder(state, action: PayloadAction<Folder>) {
            state.activeFolders.push(action.payload);
            sessionStorage.setItem('activeFolders', JSON.stringify(state.activeFolders));
        },
        setFolders(state, action: PayloadAction<Folder[]>) {
            state.activeFolders = action.payload;
            sessionStorage.setItem('activeFolders', JSON.stringify(action.payload));
        },
        clearFolders(state) {
            state.activeFolders = [];
            sessionStorage.removeItem('activeFolders');
        },
        popFoldersFromIndex(state, action: PayloadAction<number>) {
            state.activeFolders = state.activeFolders.slice(0, action.payload + 1);
            sessionStorage.setItem('activeFolders', JSON.stringify(state.activeFolders));
        },
    },
});

export const { addFolder, setFolders, clearFolders, popFoldersFromIndex } = folderSlice.actions;

export default folderSlice.reducer;
